import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import { setSelectedIndex, setSearchString, clearSelectedAndCloseMenu, setSelectedValue, setGroups, setCursorIndex, cursorMovedDown, cursorMovedUp, closeMenu, openMenu } from './actions.js';
import { getDefaultCursorIndex, getGroups, isEmpty, getCursorIndex } from './selectors.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }
function getInitialState(groups) {
  var defaultSelected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return {
    groups: groups,
    menuIsOpen: false,
    selected: defaultSelected,
    searchString: '',
    filteredGroups: null,
    cursorIndex: getDefaultCursorIndex(groups)
  };
} // eslint-disable-next-line complexity

function baseReducer(state, action) {
  var overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  switch (action.type) {
    case openMenu.type:
      return _objectSpread(_objectSpread({}, state), handleOpenMenu(state));

    case closeMenu.type:
      return _objectSpread(_objectSpread({}, state), handleCloseMenu(state));

    case cursorMovedUp.type:
      return _objectSpread(_objectSpread({}, state), {}, {
        cursorIndex: up(state, overrides)
      });

    case cursorMovedDown.type:
      return _objectSpread(_objectSpread({}, state), {}, {
        cursorIndex: down(state, overrides)
      });

    case setCursorIndex.type:
      return _objectSpread(_objectSpread({}, state), {}, {
        cursorIndex: action.cursorIndex
      });

    case setGroups.type:
      return _objectSpread({}, getInitialState(action.groups, state.selected));

    case setSelectedValue.type:
      return action.selected !== undefined ? _objectSpread(_objectSpread({}, state), {}, {
        selected: action.selected
      }) : _objectSpread({}, state);

    case setSelectedIndex.type:
      return _objectSpread(_objectSpread({}, state), setSelectedByIndex(state, action.index));

    case clearSelectedAndCloseMenu.type:
      return _objectSpread(_objectSpread({}, state), clearSelection(state));

    case setSearchString.type:
      return _objectSpread(_objectSpread({}, state), applySearchFilter(state, action.searchString, action.filterFn));

    default:
      throw new Error('Unexpected action in Select/Multiselect component');
  }
}
function selectReducer(state, action) {
  switch (action.type) {
    case setSelectedIndex.type:
      return _objectSpread(_objectSpread({}, state), setSelectedByIndex(state, action.index));

    default:
      return baseReducer(state, action);
  }
}

function handleOpenMenu(state) {
  return _objectSpread(_objectSpread({}, applySearchFilter(state, '')), {}, {
    menuIsOpen: true
  });
}

function handleCloseMenu(state) {
  return _objectSpread(_objectSpread({}, applySearchFilter(state, '')), {}, {
    menuIsOpen: false
  });
}

function setSelectedByIndex(state, index) {
  var groups = getGroups(state);

  var _index = _slicedToArray(index, 2),
      grpIndex = _index[0],
      optIndex = _index[1];

  var selectedOption = groups[grpIndex].options[optIndex];
  return {
    selected: selectedOption,
    cursorIndex: getDefaultCursorIndex(groups),
    menuIsOpen: false,
    searchString: ''
  };
}

function clearSelection(state) {
  var groups = getGroups(state);
  return {
    selected: null,
    cursorIndex: getDefaultCursorIndex(groups),
    menuIsOpen: false
  };
}

function down(state, overrides) {
  return moveCursor(state, true, overrides);
}

function up(state, overrides) {
  return moveCursor(state, false, overrides);
} // eslint-disable-next-line complexity


function moveCursor(state, isDownDirection, overrides) {
  var isGroupsEmpty = overrides.isEmpty ? overrides.isEmpty(state) : isEmpty(state);
  if (isGroupsEmpty) return getCursorIndex(state);
  var groups = overrides.getGroups ? overrides.getGroups(state) : getGroups(state);

  var _getCursorIndex = getCursorIndex(state),
      _getCursorIndex2 = _slicedToArray(_getCursorIndex, 2),
      grpIndex = _getCursorIndex2[0],
      optIndex = _getCursorIndex2[1];

  var optLenByGroup = _mapInstanceProperty(groups).call(groups, function (g) {
    return g.options ? g.options.length : 0;
  });

  var newGrpIndex = grpIndex;
  var newOptIndex = nextIndex(optIndex, isDownDirection);

  while (isIndexOutOfRange(newOptIndex, optLenByGroup[newGrpIndex]) || isIndexOutOfRange(newGrpIndex, groups.length)) {
    newGrpIndex = nextIndex(newGrpIndex, isDownDirection);

    if (isIndexOutOfRange(newGrpIndex, groups.length)) {
      newGrpIndex = isDownDirection ? 0 : groups.length - 1;
    }

    newOptIndex = isDownDirection ? 0 : optLenByGroup[newGrpIndex] - 1;
  }

  return [newGrpIndex, newOptIndex];
}

function nextIndex(index, isDownDirection) {
  return isDownDirection ? index + 1 : index - 1;
}

function isIndexOutOfRange(index, len) {
  return index < 0 || index >= len;
}

function applySearchFilter(state, searchString, filterFn) {
  if (searchString === '') {
    return _objectSpread(_objectSpread({}, getInitialState(state.groups, state.selected)), {}, {
      menuIsOpen: state.menuIsOpen
    });
  } else {
    var _context;

    var filteredGroups = _mapInstanceProperty(_context = state.groups).call(_context, function (g) {
      var _context2;

      return _objectSpread(_objectSpread({}, g), {}, {
        options: _filterInstanceProperty(_context2 = g.options).call(_context2, filterFn)
      });
    });

    return {
      searchString: searchString,
      filteredGroups: filteredGroups,
      cursorIndex: getDefaultCursorIndex(filteredGroups),
      menuIsOpen: true
    };
  }
}

export { baseReducer, getInitialState, selectReducer };
